import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create root for the main app
createRoot(document.getElementById("root")!).render(<App />);

// Add stagewise toolbar in development mode only
if (import.meta.env.DEV) {
  import('@stagewise/toolbar-react').then(({ StagewiseToolbar }) => {
    // Create a separate DOM element for the toolbar
    const toolbarContainer = document.createElement('div');
    toolbarContainer.id = 'stagewise-toolbar-container';
    document.body.appendChild(toolbarContainer);
    
    // Create a separate React root for the toolbar
    const toolbarRoot = createRoot(toolbarContainer);
    
    // Render the toolbar with basic configuration
    toolbarRoot.render(
      <StagewiseToolbar 
        config={{
          plugins: []
        }} 
      />
    );
  });
}
